module.exports = __webpack_public_path__ + "img/banner_2.7af9d4d9.jpg";